<template>
  <div>
    <div @click="toggle">
      <slot name="button"></slot>
    </div>
    <div v-show="show" @click.stop>
      <slot name="popover"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "PopoverComp",
  data() {
    return { show: false, isClickToggle: true };
  },
  methods: {
    toggle() {
      this.show = !this.show;
      this.isClickToggle = true;
    },
    hide() {
      this.show = false;
    },
    clickDocument() {
      if (!this.isClickToggle) {
        this.hide();
      }
      this.isClickToggle = false;
    }
  },
  mounted() {
    document.addEventListener("click", this.clickDocument);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.clickDocument);
  }
};
</script>
